(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-feature-accordion"] && !Shopify.designMode) return;
  try {
    
  class YGFeatureAccordion extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.isInView = false;
      this.observer = null;
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
    }

    connectedCallback() {
      if (this.isReady) return;

      this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
      this.triggers = Array.from(this.querySelectorAll('[data-accordion-trigger]'));
      this.mediaPanels = Array.from(this.querySelectorAll('[data-media-index]'));
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.triggers.forEach((trigger) => trigger.addEventListener('click', this.handleTriggerClick));
      this.items.forEach((item) => item.addEventListener('animationend', this.handleAnimationEnd));

      this.setActive(0, false);
      this.observeVisibility();
      this.isReady = true;
    }

    disconnectedCallback() {
      this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.handleTriggerClick));
      this.items?.forEach((item) => item.removeEventListener('animationend', this.handleAnimationEnd));
      this.observer?.disconnect();
      this.isReady = false;
    }

    handleTriggerClick(event) {
      const item = event.currentTarget.closest('[data-accordion-item]');
      const index = Number(item?.dataset.accordionIndex);

      if (!Number.isNaN(index)) {
        this.setActive(index, true);
      }
    }

    handleAnimationEnd(event) {
      if (event.animationName !== 'yg-feature-accordion-progress' || !this.isInView || this.prefersReducedMotion || this.items.length <= 1) return;

      const item = event.target.closest('[data-accordion-item]');
      if (!item?.classList.contains('is-active')) return;

      this.setActive(this.currentIndex + 1, true);
    }

    observeVisibility() {
      if (this.prefersReducedMotion || this.items.length <= 1) return;

      if (!('IntersectionObserver' in window)) {
        this.isInView = true;
        this.classList.add('is-playing');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const rect = entry?.boundingClientRect;
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const isInView = Boolean(entry?.isIntersecting && rect && rect.top < viewportHeight * 0.85 && rect.bottom > viewportHeight * 0.15);

          if (this.isInView === isInView) return;
          this.isInView = isInView;
          this.classList.toggle('is-playing', isInView);

          if (isInView) {
            this.restartProgress();
          }
        },
        {
          threshold: [0, 0.15, 0.5, 1]
        }
      );

      this.observer.observe(this);
    }

    setActive(index, shouldRestart) {
      if (!this.items.length) return;

      const normalizedIndex = (index + this.items.length) % this.items.length;
      this.currentIndex = normalizedIndex;

      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === normalizedIndex;
        item.classList.remove('is-active');

        const trigger = item.querySelector('[data-accordion-trigger]');
        trigger?.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      const activeItem = this.items[normalizedIndex];
      activeItem?.classList.add('is-active');

      this.mediaPanels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === normalizedIndex;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('aria-hidden', !isActive);
      });

      if (shouldRestart) {
        this.restartProgress();
      }
    }

    restartProgress() {
      if (!this.isInView || this.prefersReducedMotion || this.items.length <= 1) return;

      const activeItem = this.items[this.currentIndex];
      if (!activeItem) return;

      activeItem.classList.remove('is-active');
      activeItem.offsetHeight;
      activeItem.classList.add('is-active');
    }
  }

  if (!window.customElements.get('yg-feature-accordion')) {
    window.customElements.define('yg-feature-accordion', YGFeatureAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-linked-tab-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGLinkedTabSwiper extends HTMLElement {
    constructor() {
      super();
      this.bannerSwiper = null;
      this.textSwiper = null;
      this.isSyncing = false;
      this.currentIndex = 0;
      this.swiperWaitTimer = null;
      this.progressFrame = null;
      this.progressStartedAt = 0;
      this.playbackTimer = null;
      this.activeVideo = null;
      this.bannerLoop = false;
      this.isInView = false;
      this.visibilityObserver = null;
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);
      this.handlePrevClick = this.handlePrevClick.bind(this);
      this.handleActiveVideoTimeUpdate = this.handleActiveVideoTimeUpdate.bind(this);
      this.handleActiveVideoEnded = this.handleActiveVideoEnded.bind(this);
      this.handleActiveVideoMetadata = this.handleActiveVideoMetadata.bind(this);
    }

    connectedCallback() {
      if (this.isReady) return;

      this.bannerElement = this.querySelector('[data-banner-swiper]');
      this.textElement = this.querySelector('[data-text-swiper]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab-index]'));
      this.nextButtons = Array.from(this.querySelectorAll('[data-next]'));
      this.prevButtons = Array.from(this.querySelectorAll('[data-prev]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
        tab.addEventListener('keydown', this.handleKeydown);
      });
      this.nextButtons.forEach((button) => button.addEventListener('click', this.handleNextClick));
      this.prevButtons.forEach((button) => button.addEventListener('click', this.handlePrevClick));

      this.observeVisibility();
      this.waitForSwiper();
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });
      this.nextButtons?.forEach((button) => button.removeEventListener('click', this.handleNextClick));
      this.prevButtons?.forEach((button) => button.removeEventListener('click', this.handlePrevClick));
      window.clearTimeout(this.swiperWaitTimer);
      window.clearTimeout(this.playbackTimer);
      this.stopProgress();
      this.pauseInactiveVideos();
      this.visibilityObserver?.disconnect();
      this.bannerSwiper?.destroy(true, true);
      this.textSwiper?.destroy(true, true);
      this.isReady = false;
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        this.isInView = true;
        return;
      }

      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const rect = entry?.boundingClientRect;
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const isInView = Boolean(entry?.isIntersecting && rect && rect.top < viewportHeight * 0.85 && rect.bottom > viewportHeight * 0.15);

          if (this.isInView === isInView) return;
          this.isInView = isInView;

          if (isInView) {
            this.scheduleActiveBannerPlayback('visibility');
          } else {
            window.clearTimeout(this.playbackTimer);
            this.stopProgress();
            this.pauseInactiveVideos();
          }
        },
        {
          threshold: [0, 0.15, 0.5, 1]
        }
      );

      this.visibilityObserver.observe(this);
    }

    waitForSwiper() {
      if (!this.isConnected) return;

      if (window.Swiper) {
        this.initSwipers();
        return;
      }

      this.swiperWaitTimer = window.setTimeout(() => this.waitForSwiper(), 50);
    }

    initSwipers() {
      if (!this.bannerElement || !this.textElement || this.bannerSwiper || this.textSwiper) return;

      const slidesDesktop = Number(this.bannerElement.dataset.slidesDesktop) || 1.3;
      const slidesMobile = Number(this.bannerElement.dataset.slidesMobile) || 1;
      const gapDesktop = Number(this.bannerElement.dataset.gapDesktop) || 16;
      const gapMobile = Number(this.bannerElement.dataset.gapMobile) || 8;
      this.autoplayDuration = (Number(this.bannerElement.dataset.autoplayDuration) || 5) * 1000;
      this.bannerLoop = this.bannerElement.dataset.loop === 'true';

      this.textSwiper = new Swiper(this.textElement, {
        slidesPerView: 1,
        allowTouchMove: false,
        autoHeight: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 240
      });

      this.bannerSwiper = new Swiper(this.bannerElement, {
        slidesPerView: slidesMobile,
        spaceBetween: gapMobile,
        centeredSlides: true,
        speed: 360,
        breakpoints: {
          700: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop
          }
        },
        on: {
          slideChange: () => {
            this.syncTo(this.getActiveBannerIndex(), 'banner');
          }
        }
      });

      this.syncTo(0);
      this.isReady = true;
    }

    handleTabClick(event) {
      const index = Number(event.currentTarget.dataset.tabIndex);
      this.syncTo(index, 'tab');
    }

    handleKeydown(event) {
      const currentIndex = Number(event.currentTarget.dataset.tabIndex);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex + 1;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex - 1;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      if (nextIndex < 0) nextIndex = this.tabs.length - 1;
      if (nextIndex >= this.tabs.length) nextIndex = 0;
      this.syncTo(nextIndex, 'tab');
      this.tabs[nextIndex]?.focus();
    }

    handleNextClick() {
      const nextIndex = (this.currentIndex + 1) % this.tabs.length;
      this.syncTo(nextIndex, 'button');
    }

    handlePrevClick() {
      const prevIndex = (this.currentIndex - 1 + this.tabs.length) % this.tabs.length;
      this.syncTo(prevIndex, 'button');
    }

    syncTo(index, source) {
      if (this.isSyncing || Number.isNaN(index) || !this.tabs.length) return;

      this.isSyncing = true;
      const normalizedIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
      this.currentIndex = normalizedIndex;

      if (source !== 'banner' && this.bannerSwiper) {
        if (this.bannerLoop && this.bannerSwiper.slideToLoop) {
          this.bannerSwiper.slideToLoop(normalizedIndex);
        } else {
          this.bannerSwiper.slideTo(normalizedIndex);
        }
      }

      if (source !== 'text' && this.textSwiper) {
        this.textSwiper.slideTo(normalizedIndex);
      }

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === normalizedIndex;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      if (source === 'tab' || source === 'button') {
        this.scrollTabIntoView(normalizedIndex);
      }

      this.scheduleActiveBannerPlayback(source);

      window.requestAnimationFrame(() => {
        this.isSyncing = false;
      });
    }

    scheduleActiveBannerPlayback(source) {
      window.clearTimeout(this.playbackTimer);

      if (!this.isInView) {
        this.stopProgress();
        this.resetSlideProgress();
        this.pauseInactiveVideos();
        return;
      }

      const delay = source === 'banner' ? 0 : this.bannerSwiper?.params?.speed || 0;
      if (delay > 0) {
        this.stopProgress();
        this.resetSlideProgress();
        this.pauseInactiveVideos();
      }

      this.playbackTimer = window.setTimeout(() => {
        this.startActiveBannerPlayback();
      }, delay);
    }

    getActiveBannerIndex() {
      if (!this.bannerSwiper) return this.currentIndex;

      const realIndex = Number(this.bannerSwiper.realIndex);
      if (!Number.isNaN(realIndex)) {
        return realIndex;
      }

      const activeSlide = this.getActiveBannerSlide();
      const linkedIndex = Number(activeSlide?.dataset.linkedIndex);

      if (Number.isNaN(linkedIndex)) {
        return this.currentIndex;
      }

      return linkedIndex;
    }

    getActiveBannerSlide() {
      if (!this.bannerSwiper) return null;

      return this.bannerSwiper.slides?.[this.bannerSwiper.activeIndex] || null;
    }

    startActiveBannerPlayback() {
      if (!this.isInView) return;

      this.stopProgress();
      this.resetSlideProgress();
      this.pauseInactiveVideos();

      const activeSlide = this.getActiveBannerSlide();
      if (!activeSlide) return;

      this.setSlideProgress(activeSlide, 0);
      const video = this.getPlayableVideo(activeSlide);

      if (!video) {
        this.startTimerProgress(activeSlide);
        return;
      }

      this.activeVideo = video;
      video.muted = true;
      video.playsInline = true;
      video.currentTime = 0;
      video.addEventListener('timeupdate', this.handleActiveVideoTimeUpdate);
      video.addEventListener('ended', this.handleActiveVideoEnded);
      video.addEventListener('loadedmetadata', this.handleActiveVideoMetadata);

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          this.startTimerProgress(activeSlide);
        });
      }

      if (this.hasUsableVideoDuration(video)) {
        this.updateVideoProgress(video);
      }
    }

    getPlayableVideo(slide) {
      const videos = Array.from(slide.querySelectorAll('video'));

      return videos.find((video) => {
        const style = window.getComputedStyle(video);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    handleActiveVideoMetadata(event) {
      this.updateVideoProgress(event.currentTarget);
    }

    handleActiveVideoTimeUpdate(event) {
      this.updateVideoProgress(event.currentTarget);
    }

    handleActiveVideoEnded() {
      this.goToNextSlide();
    }

    updateVideoProgress(video) {
      if (!this.hasUsableVideoDuration(video)) return;

      const progress = Math.min(video.currentTime / video.duration, 1);
      const activeSlide = this.getActiveBannerSlide();
      this.setSlideProgress(activeSlide, progress);

      if (progress >= 1) {
        this.goToNextSlide();
      }
    }

    hasUsableVideoDuration(video) {
      return video && Number.isFinite(video.duration) && video.duration > 0;
    }

    startTimerProgress(slide) {
      if (!this.isInView) return;

      this.progressStartedAt = performance.now();

      const tick = (now) => {
        if (!this.isInView) {
          this.stopProgress();
          return;
        }

        const progress = Math.min((now - this.progressStartedAt) / this.autoplayDuration, 1);
        this.setSlideProgress(slide, progress);

        if (progress >= 1) {
          this.goToNextSlide();
          return;
        }

        this.progressFrame = window.requestAnimationFrame(tick);
      };

      this.progressFrame = window.requestAnimationFrame(tick);
    }

    goToNextSlide() {
      if (!this.isInView || !this.tabs.length) return;

      const nextIndex = (this.currentIndex + 1) % this.tabs.length;
      this.syncTo(nextIndex, 'timer');
    }

    scrollTabIntoView(index) {
      const tab = this.tabs[index];
      const tabsContainer = tab?.parentElement;
      if (!tab || !tabsContainer) return;

      tabsContainer.scrollTo({
        left: tab.offsetLeft - tabsContainer.clientWidth / 2 + tab.clientWidth / 2,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    stopProgress() {
      if (this.progressFrame) {
        window.cancelAnimationFrame(this.progressFrame);
        this.progressFrame = null;
      }

      if (this.activeVideo) {
        this.activeVideo.removeEventListener('timeupdate', this.handleActiveVideoTimeUpdate);
        this.activeVideo.removeEventListener('ended', this.handleActiveVideoEnded);
        this.activeVideo.removeEventListener('loadedmetadata', this.handleActiveVideoMetadata);
        this.activeVideo = null;
      }
    }

    pauseInactiveVideos() {
      this.querySelectorAll('video').forEach((video) => {
        if (video === this.activeVideo) return;
        video.pause();
        video.currentTime = 0;
      });
    }

    resetSlideProgress() {
      this.querySelectorAll('.yg-linked-tab-swiper__banner .swiper-slide').forEach((slide) => {
        this.setSlideProgress(slide, 0);
      });
    }

    setSlideProgress(slide, progress) {
      if (!slide) return;

      slide.style.setProperty('--yg-linked-tab-progress', progress.toFixed(4));
    }
  }

  if (!window.customElements.get('yg-linked-tab-swiper')) {
    window.customElements.define('yg-linked-tab-swiper', YGLinkedTabSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-grid"] && !Shopify.designMode) return;
  try {
    
  class YGProductGrid extends HTMLElement {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.toggleButton = this.querySelector('[data-product-grid-toggle]');
      this.toggleLabel = this.querySelector('[data-product-grid-toggle-label]');

      if (!this.toggleButton || !this.toggleLabel) return;

      this.toggleButton.addEventListener('click', this.handleToggle);
    }

    disconnectedCallback() {
      if (!this.toggleButton) return;

      this.toggleButton.removeEventListener('click', this.handleToggle);
    }

    handleToggle() {
      const isOpen = this.hasAttribute('open');
      const nextOpen = !isOpen;
      const nextLabel = nextOpen
        ? this.toggleButton.getAttribute('data-less-label')
        : this.toggleButton.getAttribute('data-more-label');

      this.toggleAttribute('open', nextOpen);
      this.toggleButton.setAttribute('aria-expanded', String(nextOpen));
      this.toggleLabel.textContent = nextLabel;
    }
  }

  if (!window.customElements.get('yg-product-grid')) {
    window.customElements.define('yg-product-grid', YGProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tab-banner"] && !Shopify.designMode) return;
  try {
    
  class YGTabBanner extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.handleClick = this.onClick.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      const initialIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.select(initialIndex < 0 ? 0 : initialIndex);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.initialized = false;
    }

    onClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      this.select(this.tabs.indexOf(tab));
    }

    onKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      const currentIndex = this.tabs.indexOf(tab);
      let nextIndex = currentIndex;
      const isRtl = getComputedStyle(this).direction === 'rtl';

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex + (isRtl ? -1 : 1);
      } else if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex + (isRtl ? 1 : -1);
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
      this.select(nextIndex, true);
    }

    onBlockSelect(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      this.select(this.tabs.indexOf(tab));
    }

    select(index, focus = false) {
      if (this.tabs.length === 0) return;

      const safeIndex = Math.min(Math.max(index, 0), this.tabs.length - 1);
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === safeIndex;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== safeIndex;
      });

      const activeTab = this.tabs[safeIndex];
      const activePanel = this.panels[safeIndex];

      if (focus) activeTab.focus();
      if (!activePanel) return;

      const imagesReady = this.preparePanelImages(activePanel);

      requestAnimationFrame(() => {
        this.updateSwiper(activePanel);

        imagesReady.then(() => {
          requestAnimationFrame(() => this.updateSwiper(activePanel));
        });
      });
    }

    preparePanelImages(panel) {
      const images = Array.from(panel.querySelectorAll('img'));

      images.forEach((image) => {
        if (image.loading === 'lazy') image.loading = 'eager';
      });

      return Promise.allSettled(
        images.map((image) => {
          if (image.complete && image.naturalWidth > 0) return Promise.resolve();
          return image.decode().catch(() => undefined);
        })
      );
    }

    updateSwiper(panel) {
      const swiperElement = panel.querySelector('yg-swiper');
      if (!swiperElement) return;

      if (swiperElement.swiper) {
        const swiper = swiperElement.swiper;
        swiper.update();

        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.updateSlidesClasses();
        }
        return;
      }

      customElements.whenDefined('yg-swiper').then(() => {
        requestAnimationFrame(() => {
          if (!swiperElement.swiper) return;

          const swiper = swiperElement.swiper;
          swiper.update();

          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.updateSlidesClasses();
          }
        });
      });
    }
  }

  if (!customElements.get('yg-tab-banner')) {
    customElements.define('yg-tab-banner', YGTabBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
